import React from "react";

const ImageSection = () => {
  return (
    <section className="relative w-full py-8 md:py-12 bg-white">
      <div className="w-full">
        <img
          src="/c1.png"
          alt="Financial Solutions"
          className="w-full h-auto object-contain"
        />
      </div>
    </section>
  );
};

export default ImageSection;

